import { FC } from 'react';

import classNames from 'classnames';

import { ITariff } from '../../store/tariff.slice';

export interface ITariffCardHeaderProps {
  tariff: ITariff;
  modal?: boolean;
  showEmptyDescription1?: boolean;
}

export const TariffCardHeader: FC<ITariffCardHeaderProps> = ({ tariff, modal, showEmptyDescription1 = true }) => {
  const hasDescription1 = Boolean(tariff.description_1 && tariff.description_1.trim() !== '');

  return (
    <div className="text-center font-manrope leading-tight">
      <h2
        className={classNames(' mb-2 font-comfortaa font-medium', {
          'text-[24px]': !modal,
          'text-[27px]': modal,
        })}
      >
        {tariff.name}
      </h2>
      {(showEmptyDescription1 || hasDescription1) && (
        <p
          className={classNames('text-black text-[16px] mb-1 min-h-[24px]', {
            'text-[16px]': !modal,
            'text-[18px]': modal,
          })}
        >
          {tariff.description_1 || ' '}
        </p>
      )}

      <p
        className={classNames('font-comfortaa font-bold text-[#C00000]', {
          'text-[28px]': !modal,
          'text-[32px]': modal,
        })}
      >
        {tariff.price.toLocaleString('ru-RU')} {tariff.currency_symbol}
      </p>
    </div>
  );
};
